import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let user_id = useDataValue({
    context: 'auth',
    path: 'access_token_data.user_id',
    viewPath: props.viewPath,
  })

  return useMemo(
    () => ({
      variables: { user_id },
      context: {
        fetchOptions: {
          headers: {
            'x-hasura-role': 'app-admin-xid',
          },
        },
      },
    }),
    [user_id]
  )
}
